import { Capacitor } from '@capacitor/core';
import { ForegroundService } from '@capawesome-team/capacitor-android-foreground-service';
import { BatteryOptimization } from '@capawesome-team/capacitor-android-battery-optimization';
import { ElMessageBox } from 'element-plus';
import { i18n } from '@/main';
import { logInfo } from './logger';

let running = false; // Start once: init re-runs on token refresh and the plugin restarts an already running service
let batteryChecked = false; // A failed start lets startKeepAlive re-run before the user answers, so ask at most once per launch

// JS dialog (hot-update friendly) asks on every launch until the app is exempt from battery optimization (#1758)
export const checkBatteryOptimization = async (): Promise<void> => {
  if (Capacitor.getPlatform() !== 'android' || batteryChecked) return;
  batteryChecked = true;
  const { enabled } = await BatteryOptimization.isBatteryOptimizationEnabled();
  if (!enabled) return;
  const { t } = i18n.global;
  const confirmed = await ElMessageBox.confirm(t('battery.message'), t('battery.title'), { confirmButtonText: t('battery.settings'), cancelButtonText: t('battery.later') }).then(() => true).catch(() => false);
  // Some ROMs lack the per-app request screen; fall back to the system-wide list so the user can exempt manually
  if (confirmed) await BatteryOptimization.requestIgnoreBatteryOptimization().catch(e => { logInfo('BatteryOptimization: Fallback To Settings List', { error: e?.message }); return BatteryOptimization.openBatteryOptimizationSettings(); });
};
// Foreground service keeps the app process from being frozen in background so print jobs are not delayed (#1757)
export const startKeepAlive = async (): Promise<void> => {
  if (Capacitor.getPlatform() !== 'android' || running) return;
  running = true;
  await ForegroundService.startForegroundService({ id: 1, title: 'POSX', body: 'POSX is running', smallIcon: 'ic_stat_posx' }).catch(e => { running = false; logInfo('KeepAlive start failed', { error: e?.message }); });
  checkBatteryOptimization().catch(e => logInfo('Battery optimization check failed', { error: e?.message })); // Not awaited: the dialog waits for the user; old APKs without the plugin only log
};
export const stopKeepAlive = async (): Promise<void> => {
  if (!running) return;
  running = false;
  await ForegroundService.stopForegroundService().catch(() => {});
};
